import {internals} from "../../lib/internal-slot-map/internals";
import {RequireInternalSlot} from "../../abstract-operation/require-internal-slot";

/**
 * https://tc39.es/ecma262/#sec-set.prototype.clear
 */
export const {clear: setPrototypeClear} = {
	clear<Value>(this: Set<Value>) {
		// Let S be the this value.
		const S = this;

		// Perform ? RequireInternalSlot(S, [[SetData]]).
		RequireInternalSlot(S, "[[SetData]]");
		internals(S)["[[SetData]]"].clear();

		// Return undefined.
		return undefined;
	}
};
